"use strict";import{ActionMenu as e}from"./src/ActionMenu.js";import{defineElement as n}from"@spectrum-web-components/base/src/define-element.js";n("sp-action-menu",e);
//# sourceMappingURL=sp-action-menu.js.map
